@if (fields && noActionRequired) {
  <div class="row">
    <div class="drug-filter-container d-flex d-flex w-100 ml-2 mr-4 justify-content-between">
      @if (config.filterAr != undefined && config.filterAr.length) {
        <div class="bookmarks-container ml-2 mr-2">
          <div class="col-12 p-0">
            <!-- {{config.filterAr|json}} -->
            @for (filter of config.filterAr; track filter) {
              <div class="fav-bookmark">
                @if (checkFilterCondition(filter)) {
                  <div class="bookmark-chip"
                    [ngClass]="filter.name == config.filterConfig.FilterName ? 'active': ''" style="cursor: pointer;">
                    <span class="" (click)="applyFilter(filter)"> {{ filter.name }}</span>
                    <!-- <i class="fa fa-filter" (click)="applyFilter(filter)"></i> -->
                    <!-- (click)="resetFilter(filter)" -->
                    @if (filter.name == config.filterConfig.FilterName) {
                      <i class="fa fa-check ml-1"></i>
                    }
                  </div>
                }
              </div>
            }
            @if (config.localStorageData && config.localStorageData['filter__'] != undefined && config.localStorageData['filter__'].length >0) {
              <a href="javascript:void(0)" title="Manage Filters" (click)="manageFilter()" class="_fav-3-dots"
                >
                <div class="_fav-3-dots-container">
                  <img src="assets/images/icon-context.svg">
                </div>
              </a>
            }
          </div>
        </div>
      }
      <div class="drug-filter-container-rgh d-flex align-items-center align-items-center">
        @if (bulkActionsConfig && singleFieldSelection && singleFieldSelection.item && singleFieldSelection.item.length > 0 ) {
          <div>
            @for (action of bulkActionsConfig.actions; track action) {
              <button type="button" (click)="onSingleActionClicked(singleFieldSelection)"
                class="primary-btn">
                <!-- <i class="fa {{action.icon ? action.icon : 'no-icon' }}" aria-hidden="true"></i> -->
                <span>{{ action.label }} </span>
              </button>
            }
          </div>
        }
        @if (extra_buttons && extra_buttons.length > 0) {
          <div>
            @for (extra of extra_buttons; track extra) {
              @if (extra.type == 'checkbox') {
                <input type="checkbox" (change)="extraButtonAction($event, extra)" class="mr-1" >
                }{{extra.title}}
              }
            </div>
          }
        </div>
      </div>
      <div class="table-action-container w-100">
        <!-- <div class="kx-dat-grid-left-box"> -->
      <!-- </div> -->
      <ng-container>
        <div class="_table-quick-action-dropdown d-flex justify-content-end pb-2">
          @if (config.secondary_uhid && rolePermissionService.checkAccessPermission('secondary_uhid',_currentResource,this.appService.getApplication())) {
            <div class="custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch"
              (click)="secondaryUhidBtn();"
              style="display:flex;flex-direction: column;align-items: end;margin-right: 0rem !important;">
              <input class="custom-control-input" type="checkbox" [checked]=config.secondary_uhid_default>
              <label class="custom-control-label custom_secondary_class" style="padding-left: 45px;"></label>
              <p class="m-0 p-0" style="margin-top: 25px !important;padding-left: 20px !important;">
                {{translateLabel('Merge UHID')}}</p>
            </div>
          }
          @if (config.ehr_view && rolePermissionService.checkAccessPermission('ehr_view',_currentResource,this.appService.getApplication())) {
            <div class="custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch"
              (click)="toggleEhrButton();"
              style="display:flex;flex-direction: column;align-items: center;margin-right: 2rem !important;">
              <input class="custom-control-input" type="checkbox" [checked]=config.ehr_view_default>
              <label class="custom-control-label" style="padding-left: 45px;"></label>
              <p class="m-0 p-0" style="margin-top: 25px !important;padding-left: 20px !important;">
                {{config!=undefined && config.toggle_info!=undefined &&
                config.toggle_info.display!=undefined?config.toggle_info.display:'EHR'}}
              </p>
            </div>
          }
        </div>
      </ng-container>
      <!--table action container placeholder : added by abhinav chauhan-->
      <div class="d-flex align-items-center">
        <!-- search Code -->
        @if (config.search == undefined || config.search || config.search == '' || (filterFieldGroup != undefined && !(isChecked > 0))) {
          <div class="grid-search-wrapper"
            [ngClass]="{'no-search':config.hideSearchBox,'has-filter':filterFieldGroup != undefined && !(isChecked > 0)}"
            >
            <div class="_filter-button-wrapper">
              @if (filterFieldGroup != undefined && !(isChecked > 0)) {
                <div class="_filter-button" [ngClass]="{'_has_filter': config.filterLabel != undefined}"
                  (click)="displayFilter()">
                  <!-- <span class="filter-text">Filter</span> -->
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </div>
              }
            </div>
            @if (!config.downloadOnly) {
              <div [hidden]="config.hideSearchBox" class="_complex-search">
                <app-complex-search
                  [ngClass]="{'d-flex': !(config.f__search != undefined && config.f__search),'d-none': (config.f__search != undefined && config.f__search)}"
                  [config]="config" (onFilterChange)="filterClick($event);" #complexSearch>
                </app-complex-search>
                <div [ngClass]="{'d-flex': (config.f__search != undefined && config.f__search),'d-none': !(config.f__search != undefined && config.f__search)}"
                  class="grid-smart-search-container align-items-center h-100 min-width-filter"
                  [hidden]="!(config.f__search != undefined && config.f__search)">
                  <span class="complex-search-pill mr-2">
                    @if (config.f__searchLabel == undefined || !config.f__searchLabel) {
                      <span class="selected-pill-item"
                        >
                        Search :
                      </span>
                    }
                    @if (!(config.f__searchLabel == undefined || !config.f__searchLabel)) {
                      <span class="selected-pill-item"
                        >
                        {{config.f__searchLabel}} :
                      </span>
                    }
                  </span>
                  {{ config.f__search}}
                  @if (config.journey_info!=undefined && config.journey_info && config.f__searchColumns=='uhId') {
                    <span class="advsearchspan_search" (click)="redirect(config.journey_info);">
                      <i aria-hidden="true" class="fa fa-file-archive-o"></i>
                    </span>
                  }
                  <span class="ml-auto mr-2" title="Clear Search" (click)="resetSearch('');">
                    <i aria-hidden="true" class="fa fa-times-circle"></i>
                  </span>
                </div>
              </div>
              }<!--face recognition icon enable-->
              <!-- <div *ngIf="config.face_recognition != undefined && config.face_recognition" (click)="openrecognition()">
              <span _ngcontent-fpd-c109="" class="face-recognition-inline-button ng-star-inserted">
                <i _ngcontent-fpd-c109="" class="ng-star-inserted"></i><img src="/assets/images/icons/face-recognition-white.svg" width="30px" height="25px"></span>
              </div> -->
              <!-- Legends Class -->
            </div>
          }
          @if (config.gridPopupValidation && config?.gridPopupIcon != undefined && utilService.isMobile() == true) {
            <button  class="btn-with-icon-label" style="margin-inline: 10px !important;" (click)="recentPatientHistory()">
              <i class="fa">
                <img src="./assets/images/{{config.gridPopupIcon}}" style="width: 17px; height: 16px;">
              </i>
              <span>{{translateLabel('recent_patient_list')}}</span>
            </button>
          }
          <!--grid checkbox actions for large screens-->
          @if (selectedItems.length > 0 || isChecked > 0) {
            <div class="checkbox-actions lg">
              @if (bulkActionsConfig && bulkActionsConfig.emit_per_action == undefined) {
                <div
                  class="checbodisplay_namex-wrapper">
                  <div class="table-button-div-box">
                    <div class="">
                      <div class="selection-container">
                        @if (selectedItems.length > 0) {
                          <a (click)="onClearClicked()"
                            class="clear-selection active"><i class="fa fa-times" aria-hidden="true"></i></a>
                          }
                          @if (bulkActionsConfig.selectedItemName == undefined) {
                            <span class="selected-items"
                              [ngPlural]="selectedItems.length" (click)="showSelectedItems();">
                              <ng-template ngPluralCase="=0">no {{plurals[1]}} selected</ng-template>
                              <ng-template ngPluralCase="=1">
                                <b>1</b> {{translateLabel(plurals[0])}} {{translateLabel('selected')}}
                                @if (evaluatedData) {
                                  <span>
                                      {{bulkActionsConfig.formattedMsg}} {{ evaluatedData }}
                                  </span>
                                }
                              </ng-template>
                              <ng-template ngPluralCase="other">
                                <b>{{selectedItems.length}}</b> {{translateLabel(plurals[1])}} {{translateLabel('selected')}}
                                @if (evaluatedData) {
                                  <span>
                                    {{bulkActionsConfig.formattedMsg}} {{ evaluatedData }}
                                  </span>
                                }
                              </ng-template>
                            </span>
                          }
                          @if (bulkActionsConfig.selectedItemName != undefined) {
                            <span class="selected-items"
                              [ngPlural]="selectedItems.length">
                              <ng-template ngPluralCase="other">
                                <b>{{selectedItems.length}}</b> {{ bulkActionsConfig.selectedItemName }}
                                selected
                                @if (evaluatedData) {
                                  <span>
                                    {{bulkActionsConfig.formattedMsg}} {{ evaluatedData }}
                                  </span>
                                }
                              </ng-template>
                            </span>
                          }
                        </div>
                      </div>
                      @if (bulkActionsConfig.actions && bulkActionsConfig.type == undefined) {
                        <div class="_checkbox-actions"
                          >
                          @for (action of bulkActionsConfig.actions; track action) {
                            <button type="button" (click)="onBulkActionClicked(action)" class="btn-with-icon-label"
                              [value]="convertString(action)"
                              [disabled]="isCountClick">
                              <i class="fa {{action.icon ? action.icon : 'no-icon' }}" aria-hidden="true"></i>
                              <span>{{translateLabel(action.label)}} </span> </button>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
              @if (legend && !utilService.isMobile()) {
                <div class="emr-legends ml-auto">
                  @for (leg of legend; track leg) {
                    <span class="emr_per_legend">@if (leg.img) {
                      <img class="source-icon" src="{{leg.img}}">
                    }
                    <label class="legend_label"> {{translateLabel(leg.display_name)}} </label>
                  </span>
                }
              </div>
            }
            <!-- {{config|json}} -->
            <div class="ml-auto table-quick-actions">
              <div class="table-quick-actions-web">
                @if (config.direct_booking_toggle_button && rolePermissionService.checkAccessPermission('doctor_availability_toggle',_currentResource,this.appService.getApplication())){
                  <div class="custom-op-action quick-action-icon">
                    <div class="chamber-case pl-1">
                      <div class="custom-control custom-switch mr-2 p-0 _switch-button">
                        <input id="chamberSwitch" (change)="toggleDirectBooking($event)" type="checkbox" class="custom-control-input"
                          [checked]="isDirectBookingEnabled">
                        <label for="chamberSwitch" class="custom-control-label" style="margin-left: 1em;"></label>
                        <p class="p-0 m-0">{{translateLabel('doctor_availability_toggle')}}</p>
                      </div>
                    </div>
                  </div>
                }
                @if (config.gridPopupValidation && config?.gridPopupIcon != undefined) {
                  <button  class="btn-with-icon-label quick-action-icon" (click)="recentPatientHistory()">
                    <i class="fa">
                      <img src="./assets/images/{{config.gridPopupIcon}}" style="width: 17px; height: 16px;">
                    </i>
                    <span>{{translateLabel('recent_patient_list')}}</span>
                  </button>
                }
                @if (config.aiSummary != undefined && config.aiSummary.load) {
                  <app-kx-ai-summary class="quick-action-icon" [config]="config.aiSummary"
                  ></app-kx-ai-summary>
                }
                @if (config.archiveConfig != undefined && (config.archiveConfig.hide_catalogue_menu == undefined || config.archiveConfig.hide_catalogue_menu == false)) {
                  <button (click)="showArchivePolicy()" type="button" class="btn-with-icon-label quick-action-icon"
                    [ngClass]="config!=undefined && config.archiveConfig!=undefined&&config.archiveConfig.selected!=undefined &&config.archiveConfig.selected.label!=undefined && (config.archiveConfig.selected.label=='Archived Data')?'active':''">
                    <i class="fa fa-folder-open" aria-hidden="true"></i>
                    <span class="">{{((config.archiveConfig.selected != undefined &&
                      config.archiveConfig.selected.label !=
                    undefined)?config.archiveConfig.selected.label:'cur_data' )| translate | async}}</span>
                  </button>
                  <div [class.show]="config.archiveConfig.open == true"
                    class="dropdown-menu paginationCount archieve-dropdown">
                    @for (achList of config.archiveConfig.list; track achList) {
                      <div class="dropdown-item" (click)="setArchivePolicy(achList)">{{
                      translateLabel(achList.label)}}</div>
                    }
                  </div>
                }
                @if (!config.downloadOnly) {
                  @if (config && config.printActions && items != null &&  items.length > 0) {
                    <div
                      style="padding-left: 0 !important;position: relative;">
                      <button class="result-per-page btn-with-icon-label quick-action-icon" [triggered]="showPrint"
                        (click)="showPrintAction('printtypes')" (clickOutside)="showPrintAction('printtypes')">
                        <i aria-hidden="true" class="fa fa-print"></i>
                        <span>{{translateLabel("Print")}} </span></button>
                        @if (showPrint) {
                          <div class="dropdown-menu paginationCount show" id="printtypes" style="width: auto;"
                            aria-labelledby="printtypes">
                            @for (data of config.printActions; track data) {
                              <span class="dropdown-item"
                                [value]="data.label" (click)="onButtonClicked(data,$event)">{{data.label | translate
                                |
                              async}}</span>
                            }
                          </div>
                        }
                      </div>
                    }
                    <!-- For Multiple download Action Start-->
                    @if (config && config.downloadActions && items != null &&  items.length > 0) {
                      <div
                        style="padding-left: 0 !important;position: relative;">
                        <button class="result-per-page btn-with-icon-label quick-action-icon" [triggered]="showDownload"
                          (click)="showdownloadAction('downloadtypes')"
                          (clickOutside)="showdownloadAction('downloadtypes')">
                          <i aria-hidden="true" class="fa fa-download"></i>
                          <span> Download </span></button>
                          @if (showDownload) {
                            <div class="dropdown-menu paginationCount show" id="downloadtypes" style="width: auto;"
                              aria-labelledby="downloadtypes">
                              @for (data of config.downloadActions; track data) {
                                <span class="dropdown-item"
                                  [value]="data.label" (click)="onButtonClicked(data)">{{data.label | translate |
                                async}}</span>
                              }
                            </div>
                          }
                        </div>
                      }
                      <!-- For Multiple download Action End-->
                      <!-- <ng-container
                      *ngIf="config && config.autorefresh != undefined && config.autorefresh &&autorefresh!=undefined && autorefresh['config']!=undefined && autorefresh['config'].autorefresh!=undefined && items != null &&  items.length > 0 && !(isChecked > 0)">
                      <div class="custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch">
                        <input class="custom-control-input " id="customSwitch1" type="checkbox"
                          [checked]="autorefresh['config'].autorefresh"
                          (change)="toggleAutoRefresh($event.target.checked);">
                          <label class="custom-control-label" for="customSwitch1">
                          </label>
                          <p class="m-0 p-0">{{'field.button.auto_refresh' | translate | async}}</p>
                        </div>
                        auto refresh feature is removed @author Sauravdeep
                      </ng-container> -->
                      @if (config && config.archive != undefined && config.archive  && config.archive.resource != undefined &&  !(isChecked > 0)) {
                        <div class="custom-control custom-switch mr-3 p-0 table-switch quick-action-icon">
                          <input [checked]="config.archive.isON" class="custom-control-input "
                            id="customSwitchArchive" type="checkbox"
                            (change)="toggleArchiveData($event.target.checked);">
                            <label class="custom-control-label" for="customSwitchArchive">
                            </label>
                            <p class="p-0 m-0"> {{(config.archive.label != undefined && config.archive.label) ?
                              (config.archive.label | translate | async) : 'field.label.archive_records' |
                            translate | async}}</p>
                          </div>
                          <!-- <label class="kx-check-wrapper for-grid m-0">
                          <input type="checkbox" class="checkbox" [checked]="autorefresh['config'].autorefresh"
                            (change)="toggleAutoRefresh($event.target.checked);">
                            <span class="kx-check"></span>
                          </label> -->
                        }
                        @if (config.secondary_uhid && rolePermissionService.checkAccessPermission('secondary_uhid',_currentResource,this.appService.getApplication())) {
                          <div class="custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch quick-action-icon"
                            (click)="secondaryUhidBtn();"
                            style="display:flex;flex-direction: column;align-items: end;margin-right: 10px !important;">
                            <input class="custom-control-input" type="checkbox" [checked]=config.secondary_uhid_default>
                            <label class="custom-control-label custom_secondary_class"
                            style="padding-left: 45px;"></label>
                            <p class="m-0 p-0" style="margin-top: 25px !important;padding-left: 20px !important;">
                            {{'Merge UHID' | translate | async}}</p>
                          </div>
                        }
                        @if (config.ehr_view && rolePermissionService.checkAccessPermission('ehr_view',_currentResource,this.appService.getApplication())) {
                          <div class="custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch quick-action-icon"
                            (click)="toggleEhrButton();"
                            style="display:flex;flex-direction: column;align-items: center;margin-right: 2rem !important;">
                            <input class="custom-control-input" type="checkbox" [checked]=config.ehr_view_default>
                            <label class="custom-control-label" style="padding-left: 45px;"></label>
                            <p class="m-0 p-0" style="margin-top: 25px !important;padding-left: 20px !important;">
                              {{config!=undefined && config.toggle_info!=undefined &&
                              config.toggle_info.display!=undefined?config.toggle_info.display:'EHR'}}
                            </p>
                          </div>
                        }
                        <ng-container>
                          @if (config.barcode_config != undefined) {
                            <div class="quick-action-icon">
                              <button type="button"
                                [ngClass]="(config.barcodeConfig != undefined && config.barcodeConfig.barcodeScan == true) ? 'btn-with-icon-label-round-back' : 'btn-with-icon-label'"
                                (click)="toggleBarcodeScan()">
                                @if (config.barcode_config != undefined) {
                                  <div>
                                    <div>
                                      <i aria-hidden="true" class="fa fa-barcode"></i>
                                    </div>
                                    <span>{{'Scan' | translate | async}}</span>
                                  </div>
                                }
                              </button>
                            </div>
                          }
                          @if (config.audit_log != undefined && config.audit_log) {
                            <div class="quick-action-collapsible quick-action-icon" [class.d-none]="tooManyQuickActions">
                              <button type="button" class="btn-with-icon-label" (click)="showAuditLogs()">
                                <div>
                                  <div>
                                    <i aria-hidden="true" class="fa fa-barcode"></i>
                                  </div>
                                  <span>{{'logs' | translate | async}}</span>
                                </div>
                              </button>
                            </div>
                          }
                          @if(masterUploadList != undefined && masterUploadList.length != undefined && masterUploadList.length > 0)
                          {
                          @for (masterUpload of masterUploadList; track $index) {
                            <div class="quick-action-icon"
                              >
                              <button type="button" class="btn-with-icon-label" (click)="openMasterUpload(masterUpload)">
                                <div>
                                  <div>
                                    <i aria-hidden="true" class="fa fa-upload"></i>
                                  </div>
                                  <span>
                                    {{(masterUpload.label !=
                                    undefined?masterUpload.label:'menu.master_upload') | translate |
                                    async}}
                                  </span>
                                </div>
                              </button>
                            </div>
                          }
                        }
                        </ng-container>
                        @if (config && config.custom_button != undefined && config.custom_button.length>0  && items != null &&  items.length > 0 && !(isChecked > 0)) {
                          <div
                            class="d-flex">
                            @for (buttons of config.custom_button; track buttons) {
                              @if ((config.ruleEngine[buttons.action] == undefined || (config.ruleEngine[buttons.action] != undefined && config.ruleEngine[buttons.action])) && !(config?.hide_download && buttons?.action == 'download')) {
                                <button
                                  type="button" class="btn-with-icon-label 10 quick-action-icon" (click)="onButtonClicked(buttons)">
                                  <i aria-hidden="true" [class]="buttons.class"></i>
                                  <span>
                                    {{buttons.label | translate | async}}
                                  </span>
                                </button>
                              }
                            }
                          </div>
                        }
                        <div>
                          <!-- *ngIf="" -->
                          @if (config.allowConfigGrid && rolePermissionService.checkAccessPermission('UPDATE_ACCOUNT_SETTINGS','user_preference','account-management')) {
                            <button
                              type="button" class="btn-with-icon-label quick-action-collapsible quick-action-icon" [class.d-none]="tooManyQuickActions" (click)="configureGrid()">
                              <i aria-hidden="true" class="fa fa-cog tq-color-cog"></i>
                              <span>
                                {{'cg' | translate | async}}
                              </span>
                            </button>
                          }
                          @if (config.bulk_action_without_checkbox) {
                            <button
                              type="button" class="btn-with-icon-label quick-action-icon" (click)="performBulkActionWithoutCheckbox()">
                              <i aria-hidden="true" class="fa fa-tasks"></i>
                              <span>
                                {{'datagrid.bulkActionWithoutCheckbox' | translate | async}}
                              </span>
                            </button>
                          }
                        </div>
                        <div class="quick-action-collapsible quick-action-icon" [class.d-none]="tooManyQuickActions">
                          @if (config.help) {
                            <button type="button" class="btn-with-icon-label" (click)="viewHelp()">
                              <i aria-hidden="true" class="fa fa-question-circle tq-color-help"></i>
                              <span>
                                {{'hp' | translate | async}}
                              </span>
                            </button>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  @if (config.table && config.tile && !utilService.isMobile()) {
                    <div class="table-view-toggle quick-action-icon">
                      @if (config.table && config.activeField == 'table') {
                        <button type="button" class="btn-with-icon-label" (click)="switchView('card_view')">
                          <i aria-hidden="true" class="fa fa-th" style="color: #EC4899;"></i>
                          <span>{{'card_view' | translate | async }}</span>
                        </button>
                      }
                      @if (config.table && config.activeField == 'tile') {
                        <button type="button" class="btn-with-icon-label" (click)="switchView('table_view')">
                          <i aria-hidden="true" class="fa fa-list"></i>
                          <span>{{'table_view' | translate | async }}</span>
                        </button>
                      }
                    </div>
                  }
                  @if (config.table && config.activeField == 'table' && (config.expandTable ==undefined || config.expandTable)) {
                    <div class="column-expand-wrapper quick-action-icon"
                      >
                      <!-- <div class="column-expand" (click)="expandColapseTable($event);">
                      <i class="fa fa-expand" aria-hidden="true"></i>
                    </div> -->
                    <div class="column-expand" (click)="expandColapseTable($event);">
                      <button type="button" class="btn-with-icon-label">
                        <i aria-hidden="true" class="fa fa-expand table-expand-icn tq-color-expand"></i>
                        <span>{{'field.label.table' | translate | async }}</span>
                      </button>
                    </div>
                  </div>
                }
                <!-- When more than 7 action icons are present, hide Logs, 
                 Configure Grid, and Help from the toolbar and show them in a single (⋮) menu after the Card View/Table icons. 
                 Reuse the existing *ngIf conditions and click handlers. Keep the current layout unchanged when there are 8 or fewer icons. -->
                <div class="quick-actions-overflow" style="position:relative;" *ngIf="tooManyQuickActions">
                  <button type="button" class="btn-with-icon-label"
                    (click)="showMoreQuickActions = !showMoreQuickActions"
                    (clickOutside)="showMoreQuickActions = false"
                    aria-label="More actions">
                    <i aria-hidden="true" class="fa fa-ellipsis-v"></i>
                  </button>
                  @if (showMoreQuickActions) {
                    <div class="dropdown-menu paginationCount show quick-actions-overflow-menu" style="left:auto; right:0;">
                      @if (config.audit_log != undefined && config.audit_log) {
                        <button type="button" class="btn-with-icon-label dropdown-item"
                          (click)="showAuditLogs(); showMoreQuickActions = false">
                          <i aria-hidden="true" class="fa fa-barcode"></i>
                          <span>{{'logs' | translate | async}}</span>
                        </button>
                      }
                      @if (config.allowConfigGrid && rolePermissionService.checkAccessPermission('UPDATE_ACCOUNT_SETTINGS','user_preference','account-management')) {
                        <button type="button" class="btn-with-icon-label dropdown-item"
                          (click)="configureGrid(); showMoreQuickActions = false">
                          <i aria-hidden="true" class="fa fa-cog tq-color-cog"></i>
                          <span>{{'cg' | translate | async}}</span>
                        </button>
                      }
                      @if (config.help) {
                        <button type="button" class="btn-with-icon-label dropdown-item"
                          (click)="viewHelp(); showMoreQuickActions = false">
                          <i aria-hidden="true" class="fa fa-question-circle tq-color-help"></i>
                          <span>{{'hp' | translate | async}}</span>
                        </button>
                      }
                    </div>
                  }
                </div>
                @if (!config.downloadOnly) {
                  <div class="">
                    @if (!utilService.isOnlyMobile() && page != null) {
                      <div class="top-pagination" [hidden]="!config.allowPagination"
                        >
                        <div [hidden]="!config.allowPagination" class="">
                          @if (itemsCount || config.noCount) {
                            <dhs-pagination [gridConfig]="config"
                              [itemsCount]="itemsCount" [limit]="limit" [startPage]="page"
                              (pageChange)="onPageChanged($event)" (onLimitChanges)="onLimit($event)"
                              (onConfigChanges)="pageConfigChange($event)">
                            </dhs-pagination>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
                <!--added by abhinav for new quick actions design-->
                <!-- Small screen print download buttons -->
                @if ((config && ((config.custom_button != undefined && config.custom_button.length>0) || config.printActions) && items != null &&  items.length > 0 && !(isChecked > 0) && !config.downloadOnly) || (config && config.view_current_data)) {
                  <div class="_table-quick-action-dropdown"
                    (click)="dropdownMenuRef.classList.toggle('show')">
                    <i aria-hidden="true" class="fa fa-ellipsis-v"></i>
                  </div>
                }
              </div>
              <!--grid checkbox actions for small screens-->
              @if (selectedItems.length > 0 || isChecked > 0) {
                <div class="checkbox-actions sm">
                  @if (bulkActionsConfig && bulkActionsConfig.emit_per_action == undefined) {
                    <div class="checbox-wrapper">
                      <div class="table-button-div-box">
                        <div class="">
                          <div class="selection-container">
                            @if (selectedItems.length > 0) {
                              <a (click)="onClearClicked()"
                                class="clear-selection active"><i class="fa fa-times" aria-hidden="true"></i></a>
                              }
                              @if (bulkActionsConfig.selectedItemName == undefined) {
                                <span class="selected-items"
                                  [ngPlural]="selectedItems.length" (click)="showSelectedItems();">
                                  <ng-template ngPluralCase="=0">no {{plurals[1]}} selected</ng-template>
                                  <ng-template ngPluralCase="=1">
                                    <b>1</b> {{plurals[0]}} selected
                                  </ng-template>
                                  <ng-template ngPluralCase="other">
                                    <b>{{selectedItems.length}}</b> {{plurals[1]}} selected
                                  </ng-template>
                                </span>
                              }
                              @if (bulkActionsConfig.selectedItemName != undefined) {
                                <span class="selected-items"
                                  [ngPlural]="selectedItems.length">
                                  <ng-template ngPluralCase="other">
                                    <b>{{selectedItems.length}}</b> {{ bulkActionsConfig.selectedItemName }} selected
                                  </ng-template>
                                </span>
                              }
                            </div>
                          </div>
                          @if (bulkActionsConfig.actions && bulkActionsConfig.type == undefined && singleFieldSelection == undefined) {
                            <div class="_checkbox-actions"
                              >
                              @for (action of bulkActionsConfig.actions; track action) {
                                <button type="button" (click)="onBulkActionClicked(action)" class="btn-with-icon-label"
                                  [value]="convertString(action)">
                                  <i class="fa {{action.icon ? action.icon : 'no-icon' }}" aria-hidden="true"></i>
                                  <span>{{ translateLabel(action.label) }} </span>
                                </button>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }

          <div class="row filter-grid">
            <ng-container>
              <div class="col-12 pl-4 pr-4"
                [hidden]="!(filterFieldGroup != undefined && filterFieldGroup.blocks.list.filter.default_open)"
                [triggered]="config.canBeTriggered" (clickOutside)="displayFilter($event)">
                <div class="grid_filter">
                  <div class="filter-body">
                    <!-- <span class="filter-arrow"><i class="fa fa-caret-up" aria-hidden="true"></i></span> -->
                    <span class="close-filter-btn" (click)="displayFilter()">
                      <i class="fa fa-times-circle" aria-hidden="true"></i></span>
                      @if (formBlock) {
                        <div class="filter-form">
                          <kx-filter (getData)="getDataFn($event)" [persistValue]="config" [config]="config.filterConfig"
                            [fields]="formBlock" (getFilterWithBtn)="doSearchWithBtn($event)"
                            (resetQuickFilter)="resetQuickFilter()" (getFilter)="doSearch($event)"
                            (resetFilter)="resetFilter($event, true)" #kxFilter>
                          </kx-filter>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            <!--added by abhinav for new quick actions design-->
            <!-- Small screen print download buttons -->
            <div class="_table-quick-actions"  #dropdownMenuRef>
              <div class="_table-quick-actions-items">
                <!-- <ng-container
                *ngIf="config && config.autorefresh != undefined && config.autorefresh &&autorefresh!=undefined && autorefresh['config']!=undefined && autorefresh['config'].autorefresh!=undefined && items != null &&  items.length > 0 && !(isChecked > 0)">
                <div class="custom-control custom-switch mr-3 p-0 table-switch">
                  <input class="custom-control-input " id="customSwitch1" type="checkbox"
                    [checked]="autorefresh['config'].autorefresh" (change)="toggleAutoRefresh($event.target.checked);">
                    <label class="custom-control-label" for="customSwitch1">
                    </label>
                    <p class="p-0 m-0"> {{'field.button.auto_refresh' | translate | async}}</p>
                  </div>
                  Remove auto refresh feature as told by nidhi mam @author Sauravdeep
                </ng-container> -->
                <ng-container>
                  @if (config.barcode_config != undefined) {
                    <div>
                      <button type="button"
                        [ngClass]="(config.barcodeConfig != undefined && config.barcodeConfig.barcodeScan == true) ? 'btn-with-icon-label-round-back' : 'btn-with-icon-label'"
                        (click)="toggleBarcodeScan()">
                        @if (config.barcode_config != undefined) {
                          <div>
                            <div>
                              <i aria-hidden="true" class="fa fa-barcode"></i>
                            </div>
                            <span>{{'Scan' | translate | async}}</span>
                          </div>
                        }
                      </button>
                    </div>
                  }
                </ng-container>
                <!-- printActions dropdown for small screens, placed before custom buttons to match web order (.table-quick-actions is hidden <=768px) -->
                @if (config.printActions && items != null && items.length > 0 && !config.downloadOnly) {
                  <div style="position: relative;">
                    <button type="button" class="btn-with-icon-label" (click)="showPrintMobile = !showPrintMobile">
                      <i aria-hidden="true" class="fa fa-print"></i>
                      <span>{{translateLabel("Print")}}</span>
                    </button>
                    @if (showPrintMobile) {
                      <div class="dropdown-menu paginationCount show" style="width: auto;">
                        @for (data of config.printActions; track data) {
                          <span class="dropdown-item" (click)="showPrintMobile = false; onButtonClicked(data,$event)">{{data.label | translate | async}}</span>
                        }
                      </div>
                    }
                  </div>
                }
                @for (buttons of config.custom_button; track buttons) {
                  @if ((config.ruleEngine[buttons.action] == undefined || (config.ruleEngine[buttons.action] != undefined && config.ruleEngine[buttons.action]))) {
                    <button type="button"
                      class="btn-with-icon-label" (click)="onButtonClicked(buttons)">
                      <i aria-hidden="true" [class]="buttons.class"></i>
                      <span>{{buttons.label | translate | async}}</span>
                    </button>
                  }
                }
                <div>
                  <!-- *ngIf="" -->
                  @if (config.allowConfigGrid && rolePermissionService.checkAccessPermission('UPDATE_ACCOUNT_SETTINGS','user_preference','account-management')) {
                    <button
                      type="button" class="btn-with-icon-label" (click)="configureGrid()">
                      <i aria-hidden="true" class="fa fa-cog tq-color-cog"></i>
                      <span>
                        {{'cg' | translate | async}}
                      </span>
                    </button>
                  }
                </div>
                <div>
                  @if (config.help) {
                    <button type="button" class="btn-with-icon-label" (click)="viewHelp()">
                      <i aria-hidden="true" class="fa fa-question-circle tq-color-help"></i>
                      <span>
                        {{'hp' | translate | async}}
                      </span>
                    </button>
                  }
                </div>
                @if (config.archiveConfig != undefined && (config.archiveConfig.hide_catalogue_menu == undefined || config.archiveConfig.hide_catalogue_menu == false)) {
                  <div>
                    <button (click)="showArchivePolicy()" type="button" class="btn-with-icon-label"
                      [ngClass]="config!=undefined && config.archiveConfig!=undefined&&config.archiveConfig.selected!=undefined &&config.archiveConfig.selected.label!=undefined && (config.archiveConfig.selected.label=='Archived Data')?'active':''">
                      <i class="fa fa-folder-open" aria-hidden="true"></i>
                      <span class="">{{((config.archiveConfig.selected != undefined &&
                        config.archiveConfig.selected.label !=
                      undefined)?config.archiveConfig.selected.label:'cur_data' )| translate | async}}</span>
                    </button>
                    <div [class.show]="config.archiveConfig.open == true"
                      class="dropdown-menu paginationCount archieve-dropdown">
                      @for (achList of config.archiveConfig.list; track achList) {
                        <div class="dropdown-item" (click)="setArchivePolicy(achList)">{{achList.label |
                        translate | async }}</div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
            @if (legend && utilService.isMobile()) {
              <div class="emr-legends ml-auto">
                @for (leg of legend; track leg) {
                  <span class="emr_per_legend">@if (leg.img) {
                    <img class="source-icon" src="{{leg.img}}">
                  }
                  <label class="legend_label"> {{leg.display_name | translate | async}} </label>
                </span>
              }
            </div>
          }
          @if ((items != null &&  items.length <= 0) && (config.showHeader!=undefined?!config.showHeader:true) && !config.downloadOnly && (config.no_records!=undefined?config.no_records:true)) {
            <div class="no-record-found"
              >
              <!-- <p>No Records Available</p> -->
              @if (!isItemsExist) {
                <div class="no-record-found-img-container">
                  <!--<img src="assets/images/icon-nodata.svg" />-->
                  <img src="assets/images/nodata-icon.svg" class="no-records-found" />
                  @if ( config && config.not_found_text==undefined) {
                    <div class="no-records-found-text">
                      <span>{{'field.label.no_records_found' | translate | async}}</span>
                    </div>
                  }
                  @if (config && config.not_found_text!=undefined) {
                    <div class="no-records-found-text">
                      <span>{{config.not_found_text | translate | async}}</span>
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (((items != null &&  items.length > 0) || (config.showHeader!=undefined?config.showHeader:false)) && !config.downloadOnly) {
            <div class="row mt-1"
              >
              <div class="_mobile-pagination-count-wrapper col-12">
                <!-- <div class="_mobile-pagination-count top"
                *ngIf="itemsCount!=undefined && itemsCount && config!=undefined && config.totalPages!=undefined">
                <span class="">{{page}}/{{config.totalPages}} RECORDS</span>
              </div> -->
              <div>
                @if (bulkActionsConfig && bulkActionsConfig?.singleSelection == undefined && enableCheckedItems && enableCheckedItems.length > 0) {
                  <div
                    >
                    <div class="custom-control custom-switch table-switch bulk-action-mobile">
                      @if (enableCheckedItems) {
                        <input class="custom-control-input " id="{{config.resource ? config.resource :'customSwitch2'}}"
                          type="checkbox" (change)="onAllChecked($event.target.checked)"
                          [checked]="selectedCount === enableCheckedItems.length && enableCheckedItems.length > 0"
                          [disabled]="enableCheckedItems.length <=0">
                        }
                        <label class="custom-control-label" for="{{config.resource ? config.resource :'customSwitch2'}}">
                        </label>
                        <p class="m-0 p-0">Select All</p>
                      </div>
                    </div>
                  }
                </div>
              </div>
              @if (config.table && config.activeField == 'table') {
                <div class="col-12 table-container" [ngClass]="items.length<=3?'min-data':''"
                  >
                  <div id="data-grid"
                    [ngClass]="config.rowClick != undefined ? 'rowclick table-responsive tableFixHead' : 'table-responsive tableFixHead'"
                    class="max-height-table-vitals">
                    <table class="resource_list_{{config.resource}}"
                      [ngClass]="[addTableClass ? 'base-table table-actions' : 'base-table', config?.main_table_class || '']">
                      <thead>
                        <tr>
                          @if (bulkActionsConfig && bulkActionsConfig?.singleSelection == undefined && enableCheckedItems && enableCheckedItems.length > 0 && !config.disableCapability) {
                            <th scope="col"
                              >
                              <label class="kx-check-wrapper for-grid m-0">
                                @if (enableCheckedItems) {
                                  <input (change)="onAllChecked($event.target.checked)"
                                    [checked]="selectedCount === enableCheckedItems.length && enableCheckedItems.length > 0"
                                    type="checkbox" class="checkbox"
                                    [disabled]="enableCheckedItems.length <=0">
                                  }
                                  <span class="kx-check"></span>
                                </label>
                              </th>
                            }
                            <!-- {{fields | json}} -->
                            @if (config.showIndex) {
                              <th scope="col" class="index-column" [title]="'Total: ' + itemsCount">#</th>
                            }
                            @for (field of fields; track field) {
                              @if (!field.hidden || (field!=undefined &&field.config!=undefined &&field.config.type!=undefined && field.config.type == 'ellipse')) {
                                <th scope="col" [attr.data-name]="field.name"
                                  [ngClass]="{'sortable kx-relative': field.sortable,'freeze':field.freeze,'center_align': field.center,'right_align': field.right}">
                                  @if (field.sortable) {
<span (click)="field.sortable ? onSort(field) : null" [ngClass]="{'fa-sort': !currentSort.get(field.name),
                                    'fa-sort-desc': currentSort.get(field.name) === -1,
                                    'fa-sort-asc': currentSort.get(field.name) === 1
                                }" class="fa fa-sort kx-table-sort">&nbsp;&nbsp;
                                    </span>
                                  }
                                  <ng-template #popTemplate>
                                    Remove Sorting
                                  </ng-template>
                                  @if (currentSort && (currentSort.get(field.name) === -1 || currentSort.get(field.name) === 1)) {
                                      <span
                                        class="fa fa-times-circle-o mr-1"
                                        [sharedPopover]="'Remove Sorting'"
                                        placement="bottom"
                                        (click)="clearSort()">
                                      </span>
                                  }
                                  @if (field.checkboxTitle) {
                                    <input class="checkbox-title" type="checkbox"
                                      (change)="onActionCheckbox($event, items, field)"
                                      #selectedAllCheckbox>
                                  }
                                  <span [ngOutsideSafeHtml]="field.heading | translate | async" class="kx-grid-th"></span>
                                  @if (field.name == 'gridButton' && field.buttonList && field.buttonList.length > 0) {
                                    <div class="table-row-actions action-btn-grid"
                                      >
                                      <b>Action</b>
                                    </div>
                                  }
                                  @if (field.config && field.config.buttonMenu && (field.config.type == 'ellipse' ||(field.config.showSettings!=undefined && field.config.showSettings) )) {
                                    <div class="table-row-actions"
                                      >
                                      @if (!isSettingsMenuOpen(field.name)) {
                                        <i class="fa fa-cog"
                                           area-hidden="true"
                                           (click)="toggleSettingsMenu(field.name, $event)">
                                        </i>
                                      }

                                      @if (isSettingsMenuOpen(field.name)) {
                                        <i class="fa fa-cog" #settingsMenu="bs-popover"
                                           area-hidden="true"
                                           [popover]="popTemplate"
                                           placement="left top"
                                           container="self"
                                           containerClass="tabelcontextualmenu table-header-menu"
                                           [outsideClick]="true"
                                           [isOpen]="true"
                                           (onHidden)="activeSettingsHeader = null"
                                           (click)="$event.stopPropagation()">
                                        </i>
                                        <ng-template #popTemplate>
                                        <div (click)="$event.stopPropagation()">
                                          <div class="pl-3 p-2 p-dropdown-item">
                                            <div class="custom-control custom-checkbox">
                                              <input type="checkbox" [checked]="config.viewAll == true"
                                                (change)="HidetoggleVisibility($event.target.checked)"
                                                class="custom-control-input" id="customCheck" name="example1">
                                                <label class="custom-control-label" for="customCheck">{{'View All'
                                                |translate |async}}</label>
                                              </div>
                                            </div>
                                            @for (action of fields; track action) {
                                              <div class="pl-3 p-2 p-dropdown-item">
                                                @if (action.heading!=''&&action.heading && action.name!=undefined &&action.name) {
                                                  <div class="custom-control custom-checkbox"
                                                    >
                                                    <input type="checkbox" [checked]="action.selected"
                                                      class="custom-control-input" id="{{action.heading}}"
                                                      (change)="toggleVisibility($event,action)"
                                                      [disabled]="action.disabled && !action.hidden">
                                                      @if (action.type == 'multiRow') {
                                                        <label class="custom-control-label"
                                                          for="{{action.heading}}">{{action.setting_heading | translate |
                                                        async}}</label>
                                                      }
                                                      @if (action.type != 'multiRow') {
                                                        <label class="custom-control-label"
                                                          for="{{action.heading}}">{{action.heading | translate |
                                                        async}}</label>
                                                      }
                                                    </div>
                                                  }
                                                </div>
                                              }
                                              <div class="pl-3 p-2 p-dropdown-item">
                                                <a href="javascript:void(0)" (click)="resetDefaultConfig()"> {{'Reset to
                                                Default' | translate | async}}</a>
                                              </div>
                                            </div>
                                            </ng-template>
                                      }
                                        </div>
                                      }
                                    </th>
                                  }
                                }
                              </tr>
                            </thead>
                            @if ((items != null &&  items.length <= 0) && (config.showHeader!=undefined && config.showHeader)) {
                              <tbody
                                >
                                <p class="pt-3 kx-no-data kx-crush-txt-100">No Records Available</p>
                              </tbody>
                            }
                            @if (items != null && items.length > 0) {
                              <tbody>
                                @for(item of items; track item; let iRow = $index) {
                                  <tr [@slideInOut]="'in'" [ngClass]="item['without@ndField']">
                                    @if (bulkActionsConfig && bulkActionsConfig?.singleSelection == undefined && enableCheckedItems && enableCheckedItems.length > 0 && !config.disableCapability) {
                                      <td scope="row" class="th-checkbox"
                                        >
                                        <div [hidden]="bulkActionsConfig.disableIf && checkDisable(item, bulkActionsConfig.disableIf)"
                                          class="form-input">
                                          <label class="kx-check-wrapper for-grid m-0">
                                            @if (bulkActionsConfig?.showCheckbox ? bulkActionsConfig?.showCheckbox(item) : true) {
                                              <input
                                                (change)="onItemChecked($event, iRow)"
                                                [checked]="selectedIndices[iRow]" type="checkbox" class="checkbox" [disabled]="isLimitSelectionReached(bulkActionsConfig)">
                                            }
                                            <span class="kx-check"></span>
                                          </label>
                                        </div>
                                      </td>
                                    }
                                    @if (config.showIndex) {
                                      <td scope="row" class="index-column">{{ (page - 1) * limit + iRow + 1 }}</td>
                                    }
                                    @for (field of fields; track field) {
                                      @if (!field.hidden && item['hiddenFieldVal_' + field.field_id] || (field!=undefined &&field.config!=undefined &&field.config.type!=undefined && field.config.type == 'ellipse')) {
                                        <td scope="row" class="cursor-pointer"
                                          [attr.rowspan]="field.rowspan && item[field.rowspan] ? item[field.rowspan] : null"
                                          [ngClass]="item['custom_class_'+field.field_id]"
                                          (click)="clickRow(field, item, iRow)"
                                          [ngStyle]="field.type == 'metro'?{'text-align':'center'}:(field.right? {'text-align':'right'}:(field.center?{'text-align':'center'}:''))">
                                          <ng-container [ngTemplateOutlet]="dataRenderer"
                                            [ngTemplateOutletContext]="{field:field, item: item,index:iRow}">
                                          </ng-container>
                                        </td>
                                      }
                                    }
                                  </tr>
                                }
                              </tbody>
                            }
                          </table>
                        </div>
                      </div>
                    }
                    @if (config.tile && config.activeField == 'tile'  && (config.card_selector == undefined ||config.card_selector == '') && items && items.length > 0) {
                      <div
                        class="col-12">
                        @for(item of items; track trackByItemId; let iRow = $index) {
                          <div [ngClass]="config.card_class ? config.card_class : 'col-12 col-sm-12 col-md-6 col-lg-4 float-left card-mobile-padding'">
                            <div #commonCardLayout class="card card-view default-view no-border-card">
                              <div class="card-top-section">
                                @if (_cardFields != undefined) {
                                  <div class="col-12 float-left p-top-section pl-2 pr-2 pt-2">
                                    @for (field of _cardFields; track field) {
                                      @if (cardHeaders != undefined && (cardHeaders.template == undefined || cardHeaders.template == '')) {
                                        <span
                                          >
                                          <p class="{{field.class_name}}">
                                            <ng-container [ngTemplateOutlet]="dataRenderer"
                                              [ngTemplateOutletContext]="{field:field, item: item,index:iRow}">
                                            </ng-container>
                                          </p>
                                        </span>
                                      }
                                    }
                                    <ng-container>
                                      @if (cardHeaders != undefined && (cardHeaders.template != undefined && cardHeaders.template != '')) {
                                        <span
                                          [ngOutsideSafeHtml]='setTemplateRef(item)'>
                                        </span>
                                      }
                                    </ng-container>
                                  </div>
                                }
                                @if (!config.disableCapability && (config.activeField == 'tile' && capabilityField != undefined && capabilityField.config && capabilityField.config.buttonMenu && capabilityField.config.type == 'ellipse') || (bulkActionsConfig && enableCheckedItems && enableCheckedItems.length > 0)) {
                                  <div class="_card-actions-container"
                                    >
                                    @if (bulkActionsConfig && enableCheckedItems && enableCheckedItems.length > 0) {
                                      <div class="card-checkbox-container _mobck">
                                        <div [hidden]="bulkActionsConfig.disableIf && checkDisable(item, bulkActionsConfig.disableIf)"
                                            class="form-input">
                                            <label class="kx-check-wrapper for-grid m-0">
                                              @if (bulkActionsConfig?.showCheckbox ? bulkActionsConfig?.showCheckbox(item) : true) {
                                                <input
                                                  (change)="onItemChecked($event, iRow)"
                                                  [checked]="selectedIndices[iRow]" type="checkbox" class="checkbox">
                                              }
                                                <span class="kx-check"></span>
                                            </label>
                                        </div>
                                    </div>
                                    }
                                    <!-- <div class="ml-auto card-buttons-container" *ngIf="field.buttonList!=undefined && field.buttonList!=undefined && field.buttonList.length>0">
                                    <ng-container *ngFor="let btn of field.buttonList">
                                      <button class="btn btn-sm mr-1" [ngClass]="btn.class?btn.class:'btn-primary'"
                                        *ngIf="btn.type==='button' &&(btn.permission_required == false || rolePermissionService.checkAccessPermission(btn.action_name,config.resource)) && checkGridButtonCondition(btn,item)"
                                        (click)="emitEllipseId(item,btn,index, $event)">
                                        <i *ngIf="btn.icon" [ngClass]="btn.icon?btn.icon:''" aria-hidden="true"></i>&nbsp;<span
                                      *ngIf="btn.label">{{btn.label | translate | async}}</span>
                                    </button>
                                  </ng-container>
                                </div> -->
                          @if (config.activeField == 'tile' && capabilityField != undefined && capabilityField.config && capabilityField.config.buttonMenu && capabilityField.config.type == 'ellipse') {
                          <div class=" card-three-dots-container card-action table-row-actions"
                              >
                              @for (action of capabilityField.config.buttonMenu; let iButton = $index; track action) {
                                <span>
                                  @if (action.show_actions==true) {
                                    <i class="fa mr-2 mt-2"
                              (click)="emitEllipseId(item,action,iRow)" [ngClass]="{
                          'fa-trash':action.action=='delete',
                          'fa-pencil':action.action=='modify',
                          'fa-eye':action.action=='view',
                          'fa-file':action.icon == undefined && ['view','delete','modify'].indexOf(action.action)==-1
                          }" [class]="action.icon"></i>
                                  }
                                </span>
                              }
                              @if (item['context_menu'] && !config.show_actions) {

                                @if (!isContextMenuOpen(iRow)) {
                                  <i class="fa fa-ellipsis-v"
                                     area-hidden="true"
                                     (click)="toggleContextMenu(iRow, $event);">
                                  </i>
                                }

                                @if (isContextMenuOpen(iRow)) {
                                  <i class="fa fa-ellipsis-v" #contextMenu="bs-popover"
                                     area-hidden="true"
                                     [popover]="popTemplate"
                                     placement="left top"
                                     container="self"
                                     containerClass="tabelcontextualmenu card-contextual-menu"
                                     [outsideClick]="true"
                                     [isOpen]="true"
                                     (onHidden)="activeContextRow = -1"
                                     (click)="$event.stopPropagation()">
                                  </i>
                                  <ng-template #popTemplate>
                                    @for (action of capabilityField.config.buttonMenu; let iButton = $index; track action) {
                                      @if (action && action.show_actions != true && (_allowedContextMenu[iRow] == undefined || _allowedContextMenu[iRow][iButton] == undefined || _allowedContextMenu[iRow][iButton])) {
                                        <button class="p-dropdown-item"
                                          (click)="hidePopUp(); emitEllipseId(item, action, iRow); activeContextRow = -1">
                                          <i class="fa {{action.icon}}"></i>{{action.label | translate | async}}
                                        </button>
                                      }
                                    }
                                  </ng-template>
                                }

                              }
                            </div>
                          }
                              </div>
                            }
                          </div>
                          <div class="card-middle-section" [id]="'card-md-sec-' +iRow" #getElementHeight>
                            <div class="col-12">
                              <div class="row">
                                @for (field of fields; track field) {
                                  @if (!field.hidden && (field.card_heading == undefined || !field.card_heading)) {
                                    <div class="col-6 pl-1 pr-1"
                                      [ngClass]="{'_taper-mobile':field.type=='nested','card-footer-action-buttons':field.freeze,'full-width-re-le':field.type!=undefined && field.type=='multiRow' ,'col-12':field.class!=undefined && field.class=='col-12-fullW'}"
                                      (click)="clickRow(field, item, iRow)">
                                      @if (field.heading && (field.card_heading == undefined || !field.card_heading)) {
                                        <span
                                          [ngOutsideSafeHtml]='field.heading | translate | async'>
                                        </span>
                                      }
                                      <p>
                                        <ng-container [ngTemplateOutlet]="dataRenderer"
                                          [ngTemplateOutletContext]="{field:field, item: item,index:iRow}">
                                        </ng-container>
                                      </p>
                                    </div>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                          <!--for common card expand/collapse-->
                          @if ('card-md-sec-' +iRow| getHeight:cardElem:'cardHeight':'height>= clientHeight?true:false') {
                            <div class="_common-card-expand-collapse"
                              (click)="commonCardLayout.classList.toggle('h-full')">
                              <img src="assets/images/icon-expand.svg" class="_card-expand" loading="lazy" alt="">
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (config.tile && config.activeField == 'tile' && config.card_selector != undefined && items && items.length > 0) {
                  <div
                    class="col-12 _common-card-container">
                    @for(item of items; track item; let iRow = $index) {
                      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 float-left _common-card">
                        <ng-template #customComponent>
                        </ng-template>
                        @for (field of fields; track field) {
                          @if ((field.config && field.config.buttonMenu && field.config.type == 'ellipse') || (bulkActionsConfig && enableCheckedItems && enableCheckedItems.length > 0)) {
                            <div class="_card-actions-container"
                              >
                              @if (bulkActionsConfig && enableCheckedItems && enableCheckedItems.length > 0) {
                                <div class="card-checkbox-container"
                                  >
                                  <div [hidden]="bulkActionsConfig.disableIf && checkDisable(item, bulkActionsConfig.disableIf)"
                                    class="form-input">
                                    <label class="kx-check-wrapper for-grid m-0">
                                      @if (bulkActionsConfig?.showCheckbox ? bulkActionsConfig?.showCheckbox(item) : true) {
                                        <input
                                          (change)="onItemChecked($event.target.checked, iRow)"
                                          [checked]="selectedIndices[iRow]" type="checkbox" class="checkbox">
                                      }
                                      <span class="kx-check"></span>
                                    </label>
                                  </div>
                                </div>
                              }
                              @if (field.config && field.config.buttonMenu && field.config.type == 'ellipse') {
                                <div class="card-three-dots-container card-action table-row-actions"
                                  >
                                  @if (item['context_menu']) {

                                    @if (!isContextMenuOpen(iRow)) {
                                      <i class="fa fa-ellipsis-v"
                                         area-hidden="true"
                                         (click)="toggleContextMenu(iRow, $event);">
                                      </i>
                                    }

                                    @if (isContextMenuOpen(iRow)) {
                                      <i class="fa fa-ellipsis-v" #contextMenu="bs-popover"
                                         area-hidden="true"
                                         [popover]="popTemplate"
                                         placement="left top"
                                         container="self"
                                         containerClass="tabelcontextualmenu"
                                         [outsideClick]="true"
                                         [isOpen]="true"
                                         (onHidden)="activeContextRow = -1"
                                         (click)="$event.stopPropagation()">
                                      </i>
                                      <ng-template #popTemplate>
                                        @for (action of field.config.buttonMenu; let iButton = $index; track action) {
                                          @if (action && (_allowedContextMenu[iRow] == undefined || _allowedContextMenu[iRow][iButton] == undefined || _allowedContextMenu[iRow][iButton])) {
                                            <button class="p-dropdown-item"
                                              (click)="hidePopUp(); emitEllipseId(item, action); activeContextRow = -1">
                                              <i class="fa {{action.icon}}"></i>{{action.label | translate | async}}
                                            </button>
                                          }
                                        }
                                      </ng-template>
                                    }

                                  }
                                </div>
                              }
                            </div>
                          }
                        }
                      </div>
                    }
                  </div>
                }
                <!--added by abhinav for mobile pagination-->
                @if (utilService.isOnlyMobile() && page != null) {
                  <div class="_mobile-pagination-container">
                    <div [hidden]="!config.allowPagination" class="">
                      @if (itemsCount || config.noCount) {
                        <dhs-pagination id="grid-mobile-pagination" [gridConfig]="config"
                          [itemsCount]="itemsCount" [limit]="limit" [startPage]="page" (pageChange)="onPageChanged($event)"
                          (onLimitChanges)="onLimit($event)" (onConfigChanges)="pageConfigChange($event)">
                        </dhs-pagination>
                      }
                    </div>
                  </div>
                }
                @if (bulkActionsConfig && bulkActionsConfig.button) {
                  <div class="col-12 data-grid-footer">
                    <div class="row">
                      <div class="col-6">
                        <button type="button" class="btn grid-axn-button" (click)="checkboxItemEmit()">
                          @for (button of bulkActionsConfig.button; track button) {
                            <span class="btn-text">{{button.label}}</span>
                          }
                        </button>
                      </div>
                    </div>
                  </div>
                }
                <ng-template #grid_popover_data let-item="item" let-field="field">
                  <span class="p-2">{{ item['mappedValue_'+field.field_id] }}</span>
                </ng-template>
                <ng-template #copyPopoverContent let-item="item">
                  <span>
                    {{ copiedFieldId === item['id'] ? 'Copied' : ('Copy to Clipboard' | translate | async) }}
                  </span>
                </ng-template>
                <ng-template #showCompositeHover let-item="item" let-field="field"><span
                [ngOutsideSafeHtml]="item| mapvalue: field.hover_format"></span></ng-template>
                <ng-template #popTemplateField let-item="item" let-field="field">
                  @if (field && field.config && field.config.buttonMenu) {
                    @for (action of field.config.buttonMenu; let iButton = $index; track action) {
                      @if (action && (_allowedContextMenu[iRow][iButton] == undefined || _allowedContextMenu[iRow][iButton])) {
                        <button class="p-dropdown-item"
                          (click)="hidePopUp();emitEllipseId((field.name_expression ? getNameExpression(field.name_expression, item):item[field.name]),action);contextMenu.hide()">
                          <i class="fa {{action.icon}}"></i>{{action.label | translate | async}}
                        </button>
                      }
                    }
                  }
                </ng-template>
                <ng-template #showPopoverHover let-item="item" let-field="field"><span
                [ngOutsideSafeHtml]="item['gn_dynamic_string'+field.field_id]"></span></ng-template>
                <ng-template #showPopover  let-item="item" let-field="field">@if (field.field_id) {
                  <span>{{item['mappedValue_'+field.field_id]}}</span>
                }</ng-template>

                <ng-template #dataRenderer let-item="item" let-field="field" let-index="index">
                
                  <!-- Checkbox -->
                
                  @if (field.checkboxTitle && item['gn_exp_'+field.field_id]) {
                  <input class="checkbox-title" type="checkbox" [checked]="item.checked === true"
                    (change)="onActionCheckbox($event, item, {checked: 'singleSelected', unchecked: 'singleDiselected', index})">
                  }
                
                  <!-- Grid color dots (non-text) -->
                
                  @if (!field.grid_color_text && item['gn_class_'+field.field_id]) {
                  @for (class_ of item['gn_class_'+field.field_id]?.split(' ') ?? []; track class_) {
                  <span [ngClass]="class_" class="data-grid-span"></span>
                  }
                  }
                
                  <span class="data-grid-span" [ngClass]="field.grid_color_text ? item['gn_class_'+field.field_id] : ''">
                
                    @switch (field.type) {
                
                    @case (undefined) {
                    <span
                        [ngClass]="(field.name === 'priority' || field.name === 'priority_name' || field.name === 'servicePriority' || field.name === 'highestPriority' || field.wrap_text)
                        ? item['gn_class_'+field.field_id] : ''"
                        [sharedPopover]="field.show_popover ? item['mappedValue_'+field.field_id] : null">
                        {{ item['mappedValue_'+field.field_id] }}
                        </span>
                    }
                    @case (!field.type) {
                    <span
                        [ngClass]="(field.name === 'priority' || field.name === 'priority_name' || field.name === 'servicePriority' || field.name === 'highestPriority' || field.wrap_text)
                        ? item['gn_class_'+field.field_id] : ''"
                        [sharedPopover]="field.show_popover ? item['mappedValue_'+field.field_id] : null">
                        {{ item['mappedValue_'+field.field_id] }}
                        </span>
                    }
                
                    @case ('auto_column') {
                    {{ item['mappedValue_'+field.field_id] }}
                    }
                    
                    @case ('compositehtmlwithclick') {
                    <span class='d-flex' [ngClass]="field.class_name ? field.class_name : ''">
                      <span class="data-grid-span new-popover-class" [ngOutsideSafeHtml]="item['mappedValue_' + field.field_id]"
                        #contextMenu='bs-popover' [popoverContext]="{ item: item, field: field }"
                        [popover]='field && field.config && field.config.buttonMenu && field.finalResult ? popTemplateField : false'
                        placement='left top' container='body' containerClass='tabelcontextualmenu' [outsideClick]='true'
                        (click)='threeDotsclick(iRow, (field.name_expression ? getNameExpression(field.name_expression, item) : item[field.name]), field)'></span>
                    
                      @if (field.hover_format && field.hover_format.expression && item['gn_hover_format_' + field.field_id]) {
                      <i class='fa fa-info-circle' [popover]='showCompositeHover' [popoverContext]="{ item: item, field: field }"
                        triggers='mouseenter:mouseleave' placement='top' container='body'></i>
                      }
                      <span *ngIf="field['attachedValue'] && item[field['attachedValue']]">
                        {{item[field['attachedValue']] | mask}}
                      </span>
                    </span>
                    }

                    @case ('flags') {
                      <span class="data-grid-span" [ngClass]="field.dynamic_class ? field.dynamic_class : ''">
                        @if (field.flag && field.flag.conditions && item['gn_exp_without_c_c_'+field.field_id]) {
                          <app-flags
                            [config]="{item:item,setting:field.flag}">
                          </app-flags>
                          } {{item['mappedValue_'+field.field_id]}}
                        </span>
                      }
                    
                    @case ('popover') {<span
                          [sharedPopover]="item['mappedValue_'+field.field_id]">
                          {{ item['mappedValue_'+field.field_id] }}
                          </span>
                    }
                
                    @case ('text_with_hover') {
                    <span>
                      @if (item[field.hover_data]) {
                        <i class="fa fa-info-circle" [sharedPopover]="item['gn_dynamic_string_'+field.field_id] || item[field.hover_data]"></i>
                      }
                      {{ item['mappedValue_'+field.field_id] }}
                    </span>
                    }
                
                    @case ('specialArray') {
                    <span [ngOutsideSafeHtml]="item['mappedValue_'+field.field_id]"></span>
                    }
                
                    @case ('multiRow') {
                    @if (item != undefined) {
                    <span class="data-grid-span"
                      [ngOutsideSafeHtml]="baseService.buildDyanamicStr(field.format, { data: field.multiRowKey ? item[field.multiRowKey] : item, type: 'html' })"></span>
                    }
                    }
                    
                    @case ('nested') {
                    <span class="pl-5">
                      @for (nested_item of item[field.name]; track nested_item) {
                      <div class="op-pre-medication-custom-td-container">
                        @for (nested_field of field.fields; track nested_field) {
                        <div class="op-pre-medication-custom-td">
                          @if(nested_item[nested_field.name] && nested_field.type != 'date' && nested_field.type != 'datetime') {
                            <span>{{nested_item[nested_field.name]}}</span>
                          }
                          @if(nested_item[nested_field.name] && nested_field.type == 'date') {
                            {{ nested_item[nested_field.name] | dateFormat }}
                          }
                          @if(nested_item[nested_field.name] && nested_field.type == 'datetime') {
                            {{ nested_item[nested_field.name] | dateTimeFormat }}
                          }
                        </div>
                        }
                      </div>
                      }
                    </span>
                    }
                    @case ('composite') {
                      <span
                          [ngOutsideSafeHtml]="item['mappedValue_'+field.field_id]"
                          [sharedPopover]="field.show_popover ? item['mappedValue_'+field.field_id] : null">
                          </span>
                    }
                
                    @case ('compositehtml') {
                        <span [ngOutsideSafeHtml]="getSafeHtml(item['mappedValue_' + field.field_id])"></span>
                    }
                
                    @case ('richText') {
                    <span [ngOutsideSafeHtml]="item['mappedValue_'+field.field_id]"></span>
                    }
                    
                    @case ('array') {
                    @if (!field.showImage) {
                    <span [ngOutsideSafeHtml]='item | mask: field | mapvalue: field' [popover]="field.show_popover?showPopover:null" [popoverContext]="{item: item, field: field}"
                      triggers="mouseenter:mouseleave" placement="top left" container="body" class="data-grid-span">
                    </span>
                      <!-- <span [ngOutsideSafeHtml]='item | mapvalue: field' [sharedPopover]="field.show_popover ? item['mappedValue_'+field.field_id] : null" >
                      </span>
                     -->
                    } @else if (field.showImage) {
                    <span [ngOutsideSafeHtml]='item | mapvalue: field' [popover]="field.show_popover?showPopover:null" [popoverContext]="{item: item, field: field}"
                      triggers="mouseenter:mouseleave" placement="top left" container="body" class="data-grid-span link"
                      (click)="viewDoc(item,field)">
                    </span>
                    }
                    }
                    @case ('timeArray') {
                    @if (!field.showImage) {
                    <span [ngOutsideSafeHtml]='item | mapvalue: field' [popover]="field.show_popover?showPopover:null" [popoverContext]="{item: item, field: field}"
                      triggers="mouseenter:mouseleave" placement="top left" container="body" class="data-grid-span">
                    </span>
                    } @else if (field.showImage) {
                    <span [ngOutsideSafeHtml]='item | mapvalue: field' [popover]="field.show_popover?showPopover:null" [popoverContext]="{item: item, field: field}"
                      triggers="mouseenter:mouseleave" placement="top left" container="body" class="data-grid-span link"
                      (click)="viewDoc(item,field)">
                    </span>
                    }
                    }
                    @case ('dateTimeArray') {
                    @if (!field.showImage) {
                    <span [ngOutsideSafeHtml]='item | mapvalue: field' [popover]="field.show_popover?showPopover:null" [popoverContext]="{item: item, field: field}"
                      triggers="mouseenter:mouseleave" placement="top left" container="body" class="data-grid-span">
                    </span>
                    } @else if (field.showImage) {
                    <span [ngOutsideSafeHtml]='item | mapvalue: field' [popover]="field.show_popover?showPopover:null"  [popoverContext]="{item: item, field: field}"
                      triggers="mouseenter:mouseleave" placement="top left" container="body" class="data-grid-span link"
                      (click)="viewDoc(item,field)">
                    </span>
                    }
                    }
                    
                    @case ('String') {
                    @if (field.showImage != undefined && field.showImage) {
                    <span [ngOutsideSafeHtml]='item | mapvalue: field' [popover]="field.show_popover?showPopover:null"
                      triggers="mouseenter:mouseleave" placement="top left" container="body" class="data-grid-span link"
                      (click)="viewDoc(item,field)">
                    </span>
                    }
                    }
                    
                    @case ('date') {
                    {{ item['mappedValue_'+field.field_id] | dateFormat }}
                    }
                    
                    @case ('datetime') {
                    {{ item['mappedValue_'+field.field_id] | dateTimeFormat }}
                    }
                
                    @case ('time') {
                    {{ item['mappedValue_'+field.field_id] | timeFormat }}
                    }
                
                    @case ('monthYear') {
                    {{ item['mappedValue_'+field.field_id] | MonthYearFormat }}
                    }
                
                    @case ('currency') {
                    {{ item.facility_id | BPcurrency }} {{ item['mappedValue_'+field.field_id] }}
                    }
                
                    @case ('link') {
                    @if (field.expression ? item['gn_exp_without_c_c_'+field.field_id] : true) {
                    <span class="link" (click)="clickOnLink(item, field)">
                      {{ field.linkName ? (field.linkName | translate | async) : item['mappedValue_'+field.field_id] }}
                    </span>
                    }
                    }
                
                    @case ('document') {
                    <app-document-viewer-with-thumbnail [documentId]="item[field.name]" [config]="field" [item]="item"
                      (click)="$event.stopPropagation()">
                    </app-document-viewer-with-thumbnail>
                    }
                    
                    @case ('compositeDate') {
                    <span class="data-grid-span">
                      {{ (item | mapvalue: field) ? (item | mapvalue: field | dateFormat) : ''}}
                    </span>
                    }
                    
                    @case ('compositeDatetime') {
                    <span class="data-grid-span">
                      {{ (item | mapvalue: field) ? (item | mapvalue: field | dateTimeFormat) : ''}}
                    </span>
                    }
                    
                    @case ('compositeTime') {
                    <span class="data-grid-span">
                      {{ (item | mapvalue: field) ? (item | mapvalue: field | timeFormat) : ''}}
                    </span>
                    }
                    @case ('commaSeprateFormat') {
                    <span class="data-grid-span">
                      {{ (item | mapvalue: field) ? (item | mapvalue: field | digitGroup:2) : ''}}
                    </span>
                    }
                    
                    @case ('commaSeprateDecimalFormat') {
                    <span class="data-grid-span">
                      {{ (item | mapvalue: field) ? (item | mapvalue: field | digitGroup:2 | decimalCurrency) : ''}}
                    </span>
                    }
                    
                    @case ('commaSeprateCurrencyFormat') {
                    <span class="data-grid-span">
                      {{item.facility_id | BPcurrency}} {{ (item | mapvalue: field) ? (item | mapvalue: field | digitGroup:2) : ''}}
                    </span>
                    }
                    
                    @case ('commaSeprateCurrencyDecimalFormat') {
                    <span class="data-grid-span">
                      {{item.facility_id | BPcurrency}} {{ (item | mapvalue: field) ? (item | mapvalue: field | digitGroup:2 |
                      decimalCurrency) : ''}}
                    </span>
                    }
                    
                    @case ('metro') {
                    <span>
                      <!-- {{ getValue(item, field)}} -->
                      @if (item | mapvalue: field) {
                      <span class="metroDot" [ngClass]="item | mapvalue: field"></span>
                      }
                      @if (!(item | mapvalue: field) && field.class_conditions == undefined) {
                      <span class="metroDot NA"></span>
                      }
                    </span>
                    }
                    
                    @case ('HashMap') {
                    @if (item['tag_data']!=undefined && item['tag_data'].length!=undefined) {
                      <span>
                      @for (key of item['tag_data']; track key) {
                        <div>{{key.key_name}}&nbsp;:&nbsp;{{key.key_value_display| mask}}</div>
                      }
                      </span>
                    }
                    }

                    @case ('json') {
                      <span>
                        <a class="mr-4" (click)="openJsonViewer(item,field)"
                          title="{{'field.label.view'  | translate | async }}">
                          <i class="fa fa-info fa-md" aria-hidden="true"></i>
                        </a>
                      </span>
                    }


                    
                    <!-- @default {
                                                                                                    {{ item['mappedValue_'+field.field_id] }}
                                        } -->
                    
                    }
                
                  </span>

                   <!--Text-->
                  @if (field.type === 'grid_popover_data') {
                    <span>
                      <div class="d-flex align-items-center">
                        <!-- Copy button -->
                        @if (item[field.name] != '' && field.canCopy != undefined && field.canCopy) {
                          <button type="button" class="btn btn-sm"
                            (click)="copyGridCellValue($event, item, field)">
                            <img [src]="copiedFieldId === item['id'] ? 'assets/images/Copy-green.svg' : 'assets/images/Copy-blue.svg'"
                              alt="Copy Value" [popover]="copyPopoverContent" placement="top"  triggers="mouseenter:mouseleave"
                              container="body" style="width: 20px; height: 20px;" />
                            </button>
                          }
                          <!-- Grid popover -->
                          <p [popover]="grid_popover_data" placement="bottom" container="body"  triggers="mouseenter:mouseleave"
                            class="overflow_dot mb-0 me-2">
                            {{ item | mapvalue: field }}
                          </p>
                        </div>
                      </span>
                    }
                    <!-- Templates -->
                    <ng-template #grid_popover_data>
                      <span class="p-2">{{ item | mapvalue: field }}</span>
                    </ng-template>
                    <ng-template #copyPopoverContent>
                      <span>
                        {{ copiedFieldId === item['id'] ? 'Copied' : ('Copy to Clipboard' | translate | async) }}
                      </span>
                    </ng-template>
                    <!--Map-->
                    @if (field.type === 'map') {
                      <span>
                        {{ item | mapvalue: field }}
                      </span>
                    }
                    <!--Map-->
                    @if (field.type === 'image' && field.config != undefined) {
                      <span>
                        <app-image-thumb [imagedata]="{config:field.config,data:item}"> </app-image-thumb>
                      </span>
                    }
                    @if (field.type === 'icon_pic') {
                      <span>
                        @for (image of field.image_conditions; track image) {
                          <ng-template #image_popover_data>
                            <span>{{image.popover_remark ? item[image.popover_remark] : image.popover_data | translate |async}}</span>
                          </ng-template>
                          @if (checkBannerExpression(image.expression,item)) {
                            <img [popover]="field.show_popover?image_popover_data:''" class="Imageconditionflag" placement="top"
                              container="body" triggers="mouseenter:mouseleave"
                              src="assets/images/{{image.path}}">
                            }
                          }
                        </span>
                      }
                      <!--Link-->
                      @if (field.type === 'document') {
                        <span>
                        </span>
                      }
                      @if (field.config && field.config.type === 'link') {
                        <a [class.not-active]="!item[field.config.key]"
                          routerLink="{{ buildRoute(field.config.route, item[field.config.key]) }}">
                          {{ item | mapvalue: field }}
                        </a>
                      }
                      <!--Time-->
                      @if (field.config && field.config.type === 'time') {
                        <span>
                          {{ item | mapvalue: field ? getTimeVal(item | mapvalue: field) : '' }}
                        </span>
                      }
                      <!--Date witout time-->
                      @if (field.config && field.config.type === 'dateWithoutTime') {
                        <span>
                          {{ item | mapvalue: field ? dateToString(item | mapvalue: field) : '' }}
                        </span>
                      }
                      <!-- Dictionary display configValue with comma sepereated -->
                      @if (field.config && field.config.type == 'dictionary') {
                        <span>{{ getFormattedDictionaryValue(item | mapvalue:
                          field, field.name)}}
                        </span>
                      }
                      <!-- for fa icon  -->
                      @if (field.config && field.config.buttonMenu && field.config.type == 'gridAction') {
                        <span>
                          @for (action of field.config.buttonMenu; track action; let i = $index) {
                            <a class="mr-4" (click)="emitId(item[field.config.key],i)"
                              >
                              <i class="fa fa-save fa-lg" aria-hidden="true"></i>
                            </a>
                          }
                        </span>
                      }

                  <!-- Added Missed Code -->

                  @if (field.buttonList!=undefined && field.buttonList!=undefined && field.buttonList.length>0 && (field.mobile_view!=false || (field.mobile_view==false && !utilService.isOnlyMobile()))) {
                    <div class="d-flex"
                      >
                      @for (btn of field.buttonList; track btn) {
                        @if (btn.type==='button' &&(btn.permission_required == false || rolePermissionService.checkAccessPermission(btn.action_name,config.resource)) && checkGridButtonCondition(btn,item)) {
                          <button type="button" class="btn btn-sm mr-1" [ngClass]="btn.class?btn.class:'btn-primary'"
                            (click)="emitEllipseId(item,btn,index, $event)">
                            @if (btn.img) {
                              <div class="table-action-btn-img">
                                <img src="/assets/images/{{btn.img}}">
                              </div>
                            }
                            @if (btn.icon) {
                              <i [ngClass]="btn.icon?btn.icon:''" aria-hidden="true"></i>
                              }&nbsp;@if (btn.label) {
                              <span
                              >{{btn.label | translate | async}}</span>
                            }
                          </button>
                        }
                      }
                    </div>
                  }

                    @if (!config.disableCapability && config.activeField == 'table' && field.config && config.table && field.config.buttonMenu && field.config.type == 'ellipse') {
  <div [ngClass]="config.table && config.activeField == 'table' ? 'table-row-actions d-flex justify-content-center' : 'justify-content-center d-flex card-action table-row-actions'">
    @if (item['context_menu']) {

      @if (!isContextMenuOpen(index)) {
        <i class="fa fa-ellipsis-v"
           area-hidden="true"
           (click)="toggleContextMenu(index, $event)">
        </i>
      }

      @if (isContextMenuOpen(index)) {
        <i class="fa fa-ellipsis-v" #contextMenu="bs-popover"
           area-hidden="true"
           [popover]="popTemplate"
           placement="left top"
           container="self"
           containerClass="tabelcontextualmenu"
           [outsideClick]="true"
           [isOpen]="true"
           (onHidden)="activeContextRow = -1"
           (click)="$event.stopPropagation()">
        </i>
        <ng-template #popTemplate>
          @for (action of field.config.buttonMenu; let iButton = $index; track action) {
            @if (action && (_allowedContextMenu[index] == undefined || _allowedContextMenu[index][iButton] == undefined || _allowedContextMenu[index][iButton]) && action.show_actions != true) {
              <button class="p-dropdown-item"
                (click)="hidePopUp(); emitEllipseId(item, action, index, $event); activeContextRow = -1">
                <i class="fa {{action.icon}}"></i>{{action.label | translate | async}}
              </button>
            }
          }
        </ng-template>
      }

    }
  </div>
}
                <!-- For Button in Grid -->
                @if (field.config && field.config.type == 'button') {
                  <div class="kx-relative d-flex">
                    @for (action of field.config.buttonMenu; let i = $index; track action) {
                      @if (checkGridButtonCondition(action,item)) {
                        <button type="button" class="btn btn-sm btn-primary"
                          [attr.title]="action.title ? (action.title | translate | async) : null"
                          (click)="emitEllipseId(item,action,index)">
                          @if (action.icon != undefined) {
                            <i class="fa {{action.icon}}" aria-hidden="true"></i>
                          }
                          @if (action.imgSrc != undefined) {
                            <img [src]="action.imgSrc" [class]="action.class" />
                            }{{action.label}}
                          </button>
                        }
                      }
                    </div>
                  }
                </ng-template>

              </div>
            }

            @if (config.downloadOnly) {
              <div class="archieve-container">
                @if (config.archiveConfig && !config.archiveConfig.custom_button) {
                  <p>{{archiveMessage}}</p>
                }
                @if (config.archiveConfig && config.archiveConfig.custom_button) {
                  <p>Your data is ready</p>
                }
                <p>Please click on button.</p>
                @if (config.archiveConfig && !config.archiveConfig.custom_button) {
                  <button class="primary-btn"
                    (click)="downloadArchive()">
                    <i aria-hidden="true" class="fa fa-download"></i>
                    <span> Download </span></button>
                  }
                  @if (config.archiveConfig && config.archiveConfig.custom_button) {
                    <button class="primary-btn"
                      (click)="sendButtonData(config.archiveConfig.custom_button)">
                      <i aria-hidden="true" class="fa fa-print"></i>
                      <span> Print </span>
                    </button>
                  }
                </div>
              }
